import React from 'react';

function FinacialIcon(props: object) {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.20345 2.09008L12.1466 4.06734C12.3389 4.14424 12.4927 4.37491 12.4927 4.57813V6.40162C12.4927 6.70371 12.2455 6.95087 11.9434 6.95087H2.05705C1.75497 6.95087 1.50781 6.70371 1.50781 6.40162V4.57813C1.50781 4.37491 1.6616 4.14424 1.85384 4.06734L6.79702 2.09008C6.90687 2.04614 7.0936 2.04614 7.20345 2.09008Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4927 12.9924H1.50781V11.3447C1.50781 11.0426 1.75497 10.7954 2.05705 10.7954H11.9434C12.2455 10.7954 12.4927 11.0426 12.4927 11.3447V12.9924Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.60938 10.7956V6.95093"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.80273 10.7956V6.95093"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10.7954V6.95068"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.19922 10.7956V6.95093"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3926 10.7956V6.95093"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.960938 12.9922H13.0443"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0016 5.5779C7.45661 5.5779 7.82546 5.20905 7.82546 4.75404C7.82546 4.29903 7.45661 3.93018 7.0016 3.93018C6.54659 3.93018 6.17773 4.29903 6.17773 4.75404C6.17773 5.20905 6.54659 5.5779 7.0016 5.5779Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default FinacialIcon;
